<template lang="pug">
  div(:class="$style.desktopWrapper")
    MoveSearchDesktop(
      :item-categories="itemCategories"
      @close="$emit('close')")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import VueScrollTo from "vue-scrollto"
import { mapGetters } from "vuex"
import { GET_ITEMS_COUNT } from "~/store/listing"
Vue.use(VueScrollTo)

export default defineComponent({
  name: "FurnitureItemsDesktop",
  props: {
    itemCategories: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters("listing", {
      furniture_getItemsCount: GET_ITEMS_COUNT
    })
  },

  mounted() {
    this.$snowplow.trackIOLPDesktopButton(this.furniture_getItemsCount)
    this.$scrollTo("#lf-extension", 1000, {
      x: false,
      y: true,
      offset: -16
    })
  }
})
</script>

<style lang="css" module>
.desktopWrapper {
  @apply absolute left-[-1px] right-[-1px] top-[-1px] z-[1] cursor-auto;
}
</style>
